<button
  type="button"
  (click)="handleClick()"
  class="button"
  [disabled]="disabled"
  [ngClass]="{ disabled: disabled }"
>
  <p class="buttonText">{{ text }}</p>
</button>
